<template>
	<div class="erji-content pp50">
		<div class="container">
			<div class="erji-title">
				<h1>{{title}}</h1>
				<h2>{{titleEn}}</h2>
			</div>
			<div class="erji-content-div">
				<div class="deliver">
					<div class="deliver-div">
						<div class="deliver-title">
							应聘岗位<i>*</i>
						</div>
						<div class="deliver-radio">
							<el-radio v-model="dataObj.position" :label="item" 
							v-for="item in positionList" 
							@change="classObject.positionClass.hasError = false" :key="item.name">{{item}}</el-radio>
						</div>
						<div class="deliver-ts" v-show="classObject.positionClass.hasError">请选择应聘岗位</div>
					</div>
					<div class="deliver-div">
						<div class="deliver-title">
							个人基本信息
						</div>
						<div class="deliver-lr">
							<div class="deliver-item fl">
								<div class="deliver-item-title">
									姓名<i>*</i>
								</div>
								<div class="deliver-item-input" :class="{'has-error': classObject.usernameClass.hasError}">
									<el-input v-model="dataObj.username" 
									@focus='classObject.usernameClass.hasError = false'></el-input>
									<div class="deliver-ts" v-show="classObject.usernameClass.hasError">请填写姓名</div>
								</div>
							</div>
							<div class="deliver-item fr">
								<div class="deliver-item-title">
									性别<i>*</i>
								</div>
								<div class="deliver-radio">
									<el-radio v-model="dataObj.sex" label="男" 
									@change="classObject.sexClass.hasError = false">男</el-radio>
									<el-radio v-model="dataObj.sex" label="女" 
									@change="classObject.sexClass.hasError = false">女</el-radio>
								</div>
								<div class="deliver-ts" v-show="classObject.sexClass.hasError">请选择性别</div>
							</div>
							<div class="clear"></div>
							<div class="deliver-item fl">
								<div class="deliver-item-title">
									电话<i>*</i>
								</div>
								<div class="deliver-item-input" :class="{'has-error': classObject.telClass.hasError}">
									<el-input v-model="dataObj.tel" @focus='classObject.telClass.hasError = false'></el-input>
									<div class="deliver-ts" v-show="classObject.telClass.hasError">请填写正确的电话</div>
								</div>
							</div>
							<div class="deliver-item fr">
								<div class="deliver-item-title">
									邮箱<i>*</i>
								</div>
								<div class="deliver-item-input" :class="{'has-error': classObject.emailClass.hasError}">
									<el-input v-model="dataObj.email" 
									@focus='classObject.emailClass.hasError = false'></el-input>
									<div class="deliver-ts" v-show="classObject.emailClass.hasError">请填写正确的邮箱</div>
								</div>
							</div>
							<div class="clear"></div>
							<div class="deliver-item fl">
								<div class="deliver-item-title">
									出生日期<i>*</i>
								</div>
								<div class="deliver-item-input" :class="{'has-error': classObject.birthdayClass.hasError}">
									<el-date-picker
										v-model="dataObj.birthday"
										format="yyyy 年 MM 月 dd 日"
										value-format="yyyy-MM-dd"
										type="date"
										@focus="classObject.birthdayClass.hasError = false"
										>
									</el-date-picker>
									<div class="deliver-ts" v-show="classObject.birthdayClass.hasError">请选择出生日期</div>
								</div>
							</div>
							<div class="deliver-item fr">
								<div class="deliver-item-title">
									地址<i>*</i>
								</div>
								<div class="deliver-item-input" :class="{'has-error': classObject.addressClass.hasError}">
									<div class="deliver-item-address">
										<el-cascader
											:options="options"
											v-model="address0"
											@change="handleChange"
											placeholder="请选择省市区"
											:props="{ expandTrigger: 'hover' }"
											>
										</el-cascader>
									</div>
									<el-input v-model="address2" placeholder="详细地址"
										@change="connect"
									></el-input>
									<div class="deliver-ts" v-show="classObject.addressClass.hasError">请输入地址</div>
								</div>
							</div>
							<div class="clear"></div>
						</div>
					</div>
					<div class="deliver-div">
						<div class="deliver-title">
							教育背景
						</div>
						<div class="deliver-lr">
							<div class="deliver-item fl">
								<div class="deliver-item-title">
									最高学历<i>*</i>
								</div>
								<div class="deliver-item-input" 
								:class="{'has-error': classObject.highest_degreeClass.hasError}">
									<el-input v-model="dataObj.highest_degree" 
									@focus="classObject.highest_degreeClass.hasError = false"></el-input>
									<div class="deliver-ts" v-show="classObject.highest_degreeClass.hasError">请填写最高学历</div>
								</div>
							</div>
							<div class="deliver-item fr">
								<div class="deliver-item-title">
									毕业时间<i>*</i>
								</div>
								<div class="deliver-item-input" 
								:class="{'has-error': classObject.graduation_timeClass.hasError}">
									<el-date-picker
										v-model="dataObj.graduation_time"
										format="yyyy 年 MM 月 dd 日"
										value-format="yyyy-MM-dd"
										type="date"
										:editable="false"
										@focus="classObject.graduation_timeClass.hasError = false"
										>
									</el-date-picker>
									<div class="deliver-ts" v-show="classObject.graduation_timeClass.hasError">请选择出生日期</div>
								</div>
							</div>
							<div class="clear"></div>
							<div class="deliver-item fl">
								<div class="deliver-item-title">
									毕业学校<i>*</i>
								</div>
								<div class="deliver-item-input"
								:class="{'has-error': classObject.school_of_graduationClass.hasError}">
									<el-input v-model="dataObj.school_of_graduation" 
									@focus="classObject.school_of_graduationClass.hasError = false"></el-input>
									<div class="deliver-ts" v-show="classObject.school_of_graduationClass.hasError">请填写毕业学校</div>
								</div>
							</div>
							<div class="deliver-item fr">
								<div class="deliver-item-title">
									所学专业<i>*</i>
								</div>
								<div class="deliver-item-input" 
								:class="{'has-error': classObject.zhuanyeClass.hasError}">
									<el-input v-model="dataObj.zhuanye" 
									@focus="classObject.zhuanyeClass.hasError = false"></el-input>
									<div class="deliver-ts" v-show="classObject.zhuanyeClass.hasError">请填写所学专业</div>
								</div>
							</div>
							<div class="clear"></div>
							<div class="deliver-item">
								<div class="deliver-item-title">
									其它培训经历
								</div>
								<div class="deliver-item-input">
									<el-input
									  type="textarea"
									  :autosize="{minRows: 4}"
									  v-model="dataObj.training_record">
									</el-input>
									
								</div>
							</div>
						</div>
					</div>
					<div class="deliver-div">
						<div class="deliver-title">
							工作履历<i>*</i>
						</div>
						<div class="deliver-item" style="margin-top: 0;">
							<div class="deliver-item-input" :class="{'has-error': classObject.work_experienceClass.hasError}">
								<el-input
								  type="textarea"
								  :autosize="{minRows: 4}"
								  v-model="dataObj.work_experience"
									@focus="classObject.work_experienceClass.hasError = false"
									>
								</el-input>
								<div class="deliver-ts" v-show="classObject.work_experienceClass.hasError">请填写所学专业</div>
							</div>
						</div>
						<div class="deliver-item">
							<div class="deliver-item-title">
								自我评价<i>*</i>
							</div>
							<div class="deliver-item-input" :class="{'has-error': classObject.self_evaluationClass.hasError}">
								<el-input
								  type="textarea"
								  :autosize="{minRows: 4}"
								  v-model="dataObj.self_evaluation"
									@focus="classObject.self_evaluationClass.hasError = false"
									>
								</el-input>
								<div class="deliver-ts" v-show="classObject.self_evaluationClass.hasError">请填写自我评价</div>
							</div>
						</div>
						<div class="deliver-item">
							<div class="deliver-item-title">
								期望薪资（月薪）<i>*</i>
							</div>
							<div class="deliver-item-input" 
							:class="{'has-error': classObject.expected_monthly_salaryClass.hasError}">
								<el-input v-model="dataObj.expected_monthly_salary"
								@focus="classObject.expected_monthly_salaryClass.hasError = false"
								></el-input>
								<div class="deliver-ts" v-show="classObject.self_evaluationClass.hasError">请填写期望薪资（月薪）</div>
							</div>
						</div>
						<div class="deliver-item">
							<div class="deliver-item-title">
								附件上传
							</div>
							<div class="deliver-item-input">
								<el-upload
								  class="upload-demo"
									:limit="1"
									:file-list='fileList'
									accept='.doc,.docx,.zip,.rar,.pdf'
									:before-upload="uploadBefore"
									:on-success="uploadSuccess"
									:on-error='uploadError'
								  action="https://www.mtdz.com/api/upload">
								  <el-button size="small" type="primary">点击上传</el-button>
								  <div slot="tip" class="el-upload__tip">请选择小于50M的文件进行上传</div>
								</el-upload>
							</div>
						</div>
					</div>
					<div class="deliver-btn">
						<el-button type="primary" icon="el-icon-edit" @click="res_postData()">投递简历</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { regionDataPlus , CodeToText } from 'element-china-area-data'
	export default{
		name:'deliver',
		data(){
			return{
				title:'人才招聘',
				titleEn:'join us',
				options: regionDataPlus,
				selectedOptions: [],
				positionList:[
					'水文地质','测绘工程','环境工程','灾害地质','工程地质','物探','钻探','给排水工程',
					'供热通风与空调工程','建筑环境与设备工程','工程造价','工程管理','土木工程'
				],
				address0:'',
				address1:'',
				fileList:[],
				address2:'',
				dataObj:{
					position:'',
					username:'',
					sex:'',
					tel:'',
					email:'',
					birthday:'',
					address:'',
					highest_degree:'',
					graduation_time:'',
					school_of_graduation:'',
					zhuanye:'',
					training_record:'',
					work_experience:'',
					self_evaluation:'',
					expected_monthly_salary:'',
					file:{}
				},
				classObject:{
					positionClass: {hasError: false},
					usernameClass: {hasError: false},
					sexClass: {hasError: false},
					telClass: {hasError: false},
					emailClass: {hasError: false},
					birthdayClass: {hasError: false},
					addressClass: {hasError: false},
					highest_degreeClass: {hasError: false},
					graduation_timeClass: {hasError: false},
					school_of_graduationClass: {hasError: false},
					zhuanyeClass: {hasError: false},
					work_experienceClass: {hasError: false},
					self_evaluationClass: {hasError: false},
					expected_monthly_salaryClass: {hasError: false}
				}
				
			}
		},
		methods:{
			connect(){
				if(this.address1 != '' && this.address2 != ''){
					this.dataObj.address = this.address1 + this.address2;
				}
				this.classObject.addressClass.hasError = false;
			},
			uploadBefore(e){
				console.log('eee',e);
				this.dataObj.file = e;
				return
			},
			changeFile(e){
				const files = event.target.files
				const data = new FormData()
				data.set("file", files);
				// editUserPhoto(data).then(res => {
				// 	console.log(res)
				// })
				console.log(data,files)
				// this.dataObj.file = data
			},
			uploadSuccess(e){
				console.log('uploadSuccess',e);
				this.dataObj.file = e.src;
			},
			uploadError(e){
				console.log('uploadError',e);
			},
			handleChange (value) {
				let valuetText = value.map(item=>{return CodeToText[item]})
				this.address1 = valuetText.join('').toString();
				this.connect();
			},
			/**
			 * 验证电子邮箱格式
			 */
			email(value) {
			    return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(value)
			},
			/**
			 * 验证手机格式
			 */
			mobile(value) {
			    return /^1([3589]\d|4[5-9]|6[1-2,4-7]|7[0-8])\d{8}$/.test(value)
			},
			//验证提交字段非空
			paramsValidate (params) {
				let flag = true;
			 // console.log(params)
				for(var key in params){
					if(key != 'training_record' && key != 'file'){
						if(params[key] != '0' && !params[key] ){
							// console.log(params)
							if(params.position == ''){
								this.classObject.positionClass.hasError = true
							}else{
								this.classObject.positionClass.hasError = false;
							}
							if(params.username == ''){
								this.classObject.usernameClass.hasError = true
							}else{
								this.classObject.usernameClass.hasError = false;
							}
							
							if(params.sex == ''){
								this.classObject.sexClass.hasError = true
							}else{
								this.classObject.sexClass.hasError = false;
							}
							
							if(params.tel == ''){
								this.classObject.telClass.hasError = true
							}else{
								this.classObject.telClass.hasError = false;
							}
							
							if(params.tel == ''){
								this.classObject.emailClass.hasError = true
							}else{
								this.classObject.emailClass.hasError = false;
							}
							
							if(params.birthday == ''){
								this.classObject.birthdayClass.hasError = true
							}else{
								this.classObject.birthdayClass.hasError = false;
							}
							
							if(params.address == ''){
								this.classObject.addressClass.hasError = true
							}else{
								this.classObject.addressClass.hasError = false;
							}
							
							if(params.highest_degree == ''){
								this.classObject.highest_degreeClass.hasError = true
							}else{
								this.classObject.highest_degreeClass.hasError = false;
							}
							
							if(params.graduation_time == ''){
								this.classObject.graduation_timeClass.hasError = true
							}else{
								this.classObject.graduation_timeClass.hasError = false;
							}
							
							if(params.school_of_graduation == ''){
								this.classObject.school_of_graduationClass.hasError = true
							}else{
								this.classObject.school_of_graduationClass.hasError = false;
							}
							
							if(params.zhuanye == ''){
								this.classObject.zhuanyeClass.hasError = true
							}else{
								this.classObject.zhuanyeClass.hasError = false;
							}
							
							if(params.work_experience == ''){
								this.classObject.work_experienceClass.hasError = true
							}else{
								this.classObject.work_experienceClass.hasError = false;
							}
							
							if(params.self_evaluation == ''){
								this.classObject.self_evaluationClass.hasError = true
							}else{
								this.classObject.self_evaluationClass.hasError = false;
							}
							
							if(params.expected_monthly_salary == ''){
								this.classObject.expected_monthly_salaryClass.hasError = true
							}else{
								this.classObject.expected_monthly_salaryClass.hasError = false;
							}
							console.log('请完善数据!');
							return false; // 终止程序
						}
					}
				}                            
				return flag;
			},
			res_postData(){
				
				if(this.paramsValidate(this.dataObj)){
					if(this.mobile(this.dataObj.tel)){
						if(this.email(this.dataObj.email)){
							
							//字段非空 电话,邮箱验证通过后
							console.log("待提交字段",this.dataObj)
							this.axios({
								method:'post',
								url:'/api/sendEmployment',
								params:this.dataObj,
								}).then(response => {
									// 处理成功情况
									alert(response.data.message);
									if(response.data.code == 200){
										this.dataObj.position = ""
										this.dataObj.username = ""
										this.dataObj.sex = ""
										this.dataObj.tel = ""
										this.dataObj.email = ""
										this.dataObj.birthday = ""
										this.dataObj.address = ""
										this.dataObj.highest_degree = ""
										this.dataObj.graduation_time = ""
										this.dataObj.school_of_graduation = ""
										this.dataObj.zhuanye = ""
										this.dataObj.training_record = ""
										this.dataObj.work_experience = ""
										this.dataObj.self_evaluation = ""
										this.dataObj.expected_monthly_salary = ""
										this.dataObj.file = ""
									}
									console.log('提交成功提示:',response);
									
								})
								.catch(error => {
									// 处理错误情况
									console.log('错误提示:',error);
								})
							
							
						}else{
							console.log("邮箱格式错误");
							this.classObject.emailClass.hasError = true
						}
					}else{
						
						console.log("电话格式错误");
						this.classObject.telClass.hasError = true
					}
				}
			},
		},
		created() {
		
		}
	}
</script>

<style>
</style>